import 'css/fonts.css';
import { graphql, StaticQuery } from 'gatsby';
import { ThemeProvider } from 'styled-components';

// eslint-disable-next-line no-use-before-define
import * as React from 'react';
import { QueryClientProvider } from 'react-query';
import { LocationProvider } from '@reach/router';
import { useTheme } from 'styles/theme';

import client from 'client';
import { QuestionnaireProvider } from 'modules/questionnaire';
import { contentSelector, isBrowser } from 'services';

// This file needs to be in the /src folder otherwise it wil
// result in a Loading (StaticQuery).
export const wrapRootElement = ({ element }) => {
  return (
    <StaticQuery
      query={query}
      render={(data) => {
        const subdomain = isBrowser && window.location.host.split('.')[0];
        const partners = contentSelector(data.allContentfulContentPartners);
        const partner = partners.find(
          (partner) => partner.subdomain === subdomain,
        );
        const { theme } = useTheme(partner);

        return (
          <LocationProvider>
            <QueryClientProvider client={client}>
              <ThemeProvider theme={theme}>
                <QuestionnaireProvider data={{ ...data, partner }}>
                  {element}
                </QuestionnaireProvider>
              </ThemeProvider>
            </QueryClientProvider>
          </LocationProvider>
        );
      }}
    />
  );
};

export default wrapRootElement;

const query = graphql`
  query Question {
    allContentfulQuestions(sort: { fields: order }) {
      edges {
        node {
          id
          questionId
          question
          relevantInfo
          type
          sliderValues {
            min
            max
            default
            step
            startIcon {
              id
              value
            }
            endIcon {
              id
              value
            }
          }
          options {
            maxAmount
            value
            answer
            type
            key
          }
          order
          infoTitle
          infoText {
            infoText
          }
          secondaryQuestion
          isVisible {
            questionId
            answerValue
          }
        }
      }
    }
    allContentfulQuestionnaireBus(sort: { fields: order }) {
      edges {
        node {
          id
          questionId
          question
          type
          sliderValues {
            min
            max
            default
            step
            units
          }
          options {
            value
            key
            showCondition
            hasFollowUpQuestion
            type
            maxAmount
            maxAmountValidation
          }
          order
          subtitle
          infoTitle
          infoText {
            infoText
          }
        }
      }
    }
    allContentfulCars(
      filter: { type: { eq: "ev" }, shouldBeInTcoTool: { eq: true } }
      sort: { fields: order }
    ) {
      edges {
        node {
          relatedModels
          actionRadius
          id
          brand
          model
          description
          size
          operationalLeasePrice
          insuranceCostsYearly
          price
          kwh
          pk
          descriptionLong
          summaryUsps {
            usp
          }
          usps {
            usps {
              title
              description
              uspImage {
                file {
                  url
                }
              }
            }
          }
          loadingCapacity
          usage {
            personenvervoer
            goederenvervoer
            opslag
          }
          trailerCapacity
          shouldBeInTcoTool
          isInVanFinder
          hasOwnPage
          loadVolume
          vehicle
          comparison
          image {
            file {
              url
            }
          }
        }
      }
    }
    allContentfulContentPartners {
      edges {
        node {
          logo {
            file {
              url
            }
          }
          id
          partner
          subdomain
          primaryColor
          primaryDeep
          secondaryColor
          about {
            about
          }
          url
          showPartner
        }
      }
    }
  }
`;
